class ProductBanner extends HTMLElement {
  connectedCallback() {
    this._slides = [...this.querySelectorAll('[data-slide]')];
    this._timerRing = this.querySelector('[data-timer-ring]');
    this._timerDot = this.querySelector('[data-timer-dot]');
    this._duration = (parseFloat(this.dataset.duration) || 6) * 1000;
    this._current = 0;
    this._nextTimer = null;

    if (!this._slides.length) return;

    this._onVisibility = () => {
      if (document.visibilityState !== 'visible') return;
      const current = this._slides[this._current];
      current.style.animation = '';
      current.style.clipPath = '';
      current.style.opacity = '1';
    };
    document.addEventListener('visibilitychange', this._onVisibility);

    this._slides.forEach((slide, i) => {
      if (i !== 0) {
        slide.style.opacity = '0';
        slide.style.pointerEvents = 'none';
      }
    });

    requestAnimationFrame(() => {
      this._updateDot(0);
      if (this._slides.length > 1) {
        this._restartRing();
        this._schedule();
      }
    });
  }

  disconnectedCallback() {
    clearTimeout(this._nextTimer);
    document.removeEventListener('visibilitychange', this._onVisibility);
  }

  _goTo(index) {
    const prev = this._current;
    if (prev === index) return;
    this._current = index;

    const prevSlide = this._slides[prev];
    const nextSlide = this._slides[index];

    prevSlide.style.zIndex = '1';
    nextSlide.style.zIndex = '2';
    nextSlide.style.opacity = '1';
    nextSlide.style.pointerEvents = '';

    nextSlide.style.animation = 'none';
    nextSlide.offsetHeight;
    nextSlide.style.animation = 'pb-wipe-in 800ms cubic-bezier(0.65, 0, 0.35, 1) forwards';

    nextSlide.addEventListener('animationend', () => {
      prevSlide.style.opacity = '0';
      prevSlide.style.pointerEvents = 'none';
      prevSlide.style.zIndex = '';
      nextSlide.style.zIndex = '';
      nextSlide.style.animation = '';
      nextSlide.style.clipPath = '';
    }, { once: true });

    this._updateDot(index);
    this._restartRing();
  }

  _updateDot(index) {
    if (!this._timerDot || !this._slides[index]) return;
    const color = getComputedStyle(this._slides[index]).getPropertyValue('--dot-color').trim();
    this._timerDot.style.backgroundColor = color || 'rgba(255,255,255,0.6)';
  }

  _restartRing() {
    if (!this._timerRing) return;
    this._timerRing.style.animation = 'none';
    this._timerRing.getBoundingClientRect();
    this._timerRing.style.animation = `pb-timer ${this._duration}ms linear forwards`;
  }

  _schedule() {
    clearTimeout(this._nextTimer);
    this._nextTimer = setTimeout(() => {
      this._goTo((this._current + 1) % this._slides.length);
      this._schedule();
    }, this._duration);
  }
}

customElements.define('product-banner', ProductBanner);
